import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/primary/landing-content-1.png")